import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.css']
})
export class ModalComponent {
  @Input() isOpen: boolean;
  @Input() title: string;
  @Output() onClose: EventEmitter<void> = new EventEmitter<void>();

  closeModal() {
    this.onClose.emit();
  }

}
